import { connect } from 'react-redux';
import { getCurrentQuery } from '@hc/redux-saga-router-plus/hclib/selectors';
import { routeChange } from '@hc/redux-saga-router-plus/hclib/actions';

import PropertyExplorerForecastChartButton from 'legacy/components/PropertyExplorerForecastChartButton';
import { getIsReportActive } from 'selectors/report-permissions';
import loadWhenReady from 'legacy/hocs/loadWhenReady';

import { SECTION_ID_FORECAST } from 'legacy/appstore/constants';

import {
  getOneYearForecastData,
  getThreeYearForecastData
} from 'selectors/chart-data';
import { analyticsEvent } from 'actions/analytics';
import { EVENTS } from 'legacy/appstore/events';

const mapStateToProps = (state) => {
  const { chartModal } = getCurrentQuery(state);
  return {
    isActive: getIsReportActive(state),
    chartModal,
    forecastOneYear: getOneYearForecastData(state),
    forecastThreeYear: getThreeYearForecastData(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClick: () => {
      dispatch(analyticsEvent(EVENTS.CHART_BUTTON_MARKET));
    },
    onClose: () => {
      dispatch(
        routeChange({
          options: { inherit: true, replace: true },
          query: { chartModal: undefined }
        })
      );
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(loadWhenReady(PropertyExplorerForecastChartButton, SECTION_ID_FORECAST));
